import BigNumber from "bignumber.js";

import { decimal } from "@/helpers/formatIntlNumber";

const STABLECOINS = ["USDC", "EUROC"];

const formatStableAmount = (
  rawAmount: string | number | undefined,
  assetCode: string | undefined,
  { forceNegative = false }: { forceNegative?: boolean } = {},
) => {
  if (rawAmount === undefined || rawAmount === null || rawAmount === "") return "—";
  const value = BigNumber(rawAmount);
  if (value.isNaN()) return "—";

  const isStable = assetCode ? STABLECOINS.includes(assetCode) : false;
  const isNegative = forceNegative || value.isNegative();
  const formatted = decimal.format(Number(value.abs().toString()));
  const symbol = isStable ? "$" : "";
  const sign = isNegative && !value.isZero() ? "-" : "";

  return `${sign}${symbol}${formatted}${assetCode ? ` ${assetCode}` : ""}`;
};

interface ReceiversAsideProps {
  numberOfReceivers?: number;
  availableBalance?: string;
  disbursementAmount?: string;
  futureBalance?: number;
  assetCode?: string;
  hasUpload: boolean;
}

export const ReceiversAside = ({
  numberOfReceivers,
  availableBalance,
  disbursementAmount,
  futureBalance,
  assetCode,
  hasUpload,
}: ReceiversAsideProps) => {
  const futureIsNegative =
    futureBalance !== undefined && BigNumber(futureBalance.toString()).isNegative();

  return (
    <aside className="DisbursementReceiversAside">
      <div className="DisbursementReceiversAside__row">
        <div className="DisbursementReceiversAside__label">Number of receivers</div>
        <div className="DisbursementReceiversAside__value">
          {hasUpload && numberOfReceivers !== undefined ? numberOfReceivers : "—"}
        </div>
      </div>
      <div className="DisbursementReceiversAside__row">
        <div className="DisbursementReceiversAside__label">Available balance</div>
        <div className="DisbursementReceiversAside__value">
          {formatStableAmount(availableBalance, assetCode)}
        </div>
      </div>
      <div className="DisbursementReceiversAside__row">
        <div className="DisbursementReceiversAside__label">Disbursement amount</div>
        <div className="DisbursementReceiversAside__value">
          {hasUpload
            ? formatStableAmount(disbursementAmount, assetCode, { forceNegative: true })
            : "—"}
        </div>
      </div>
      <div className="DisbursementReceiversAside__row">
        <div className="DisbursementReceiversAside__label">Future balance</div>
        <div
          className={`DisbursementReceiversAside__value ${
            futureIsNegative ? "DisbursementReceiversAside__value--negative" : ""
          }`}
        >
          {hasUpload && futureBalance !== undefined
            ? formatStableAmount(futureBalance.toString(), assetCode)
            : "—"}
        </div>
      </div>
    </aside>
  );
};

export const formatDisbursementAmount = formatStableAmount;
